import React from 'react';
import StatsContainer from "../Containers/StatsContainer";
import getMenuItems from "../Helpers/MainMenuItems";
import PointsContainer from "../Containers/PointsContainer";
import WeaponsContainer from "../Containers/WeaponsContainer";
import AbilitiesContainer from "../Containers/AbilitiesContainer";

const UnitDisplay = ({selectedData, handleDataItemClick, selectedMenu}) => {
    const getDatasheetByName = (name) => {
        const formattedName = name.toLowerCase();
        const allDatasheets = getMenuItems().flatMap(({datasheets}) => datasheets);
        return allDatasheets.find((datasheet) => datasheet.NAME.toLowerCase() === formattedName) || null;
    };

    return (
        <div>
            <h1 className="font-bold  text-xl  capitalize">{selectedData.NAME.toLowerCase()}</h1>
            <StatsContainer selectedData={selectedData}/>

            {selectedData.LEADER && selectedData.LEADER.length > 0 ? (
                <ul className="flex  overflow-auto  mt-3  -mx-5  bg-slate-100  no-scrollbar">
                    <li className="shrink-0  pl-5  pr-2  py-2  font-bold">Leads:</li>
                    {selectedData.LEADER.map((leaderName, index) => (
                        <li className="shrink-0  last:pr-3" key={index}>
                            <button type="button"
                                    className="p-2  capitalize  underline  underline-offset-2  decoration-slate-400"
                                    onClick={() =>
                                        handleDataItemClick(getDatasheetByName(leaderName), selectedMenu)
                                    }>
                                {leaderName.toLowerCase()}
                            </button>
                        </li>
                    ))}
                </ul>
            ) : (
                <ul className="flex  overflow-auto  mt-3  -mx-5  bg-slate-100  no-scrollbar">
                    <li className="shrink-0  pl-5  pr-2  py-2  font-bold">Lead by:</li>
                    {getMenuItems()
                        .flatMap(({datasheets}) => datasheets)
                        .filter(
                            (datasheet) =>
                                datasheet.LEADER &&
                                datasheet.LEADER
                                    .map((name) => name && name.toUpperCase())
                                    .includes(selectedData.NAME && selectedData.NAME.toUpperCase())
                        )
                        .map((leader) => (
                            <li className="shrink-0  last:pr-3" key={leader.NAME}>
                                <button type="button"
                                        className="p-2  capitalize  underline  underline-offset-2  decoration-slate-400"
                                        onClick={() =>
                                            handleDataItemClick(leader, leader.menu, false)
                                        }>
                                    {leader.NAME.toLowerCase()}
                                </button>
                            </li>
                        ))}
                </ul>
            )}
            <PointsContainer unitName={selectedData.NAME}/>
            <WeaponsContainer isMeleeTable={false} weapons={selectedData['RANGED WEAPONS']}/>
            <WeaponsContainer isMeleeTable={true} weapons={selectedData['MELEE WEAPONS']}/>
            <AbilitiesContainer selectedData={selectedData}/>
        </div>
    );
};

export default UnitDisplay;